module.exports = __webpack_public_path__ + "static/img/slide6.656a73fc.jpg";